import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';

import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES } from '../config';
import translationEN from '../i18n/en.json';
import translationBN from '../i18n/bn.json';
import translationFR from '../i18n/fr.json';
import translationES from '../i18n/es.json';

const resources = {
  en: {
    translation: translationEN,
  },
  bn: {
    translation: translationBN,
  },
  fr: {
    translation: translationFR,
  },
  es: {
    translation: translationES,
  },
};

const supportedLanguages = SUPPORTED_LANGUAGES ? SUPPORTED_LANGUAGES.split(',') : ['en'];

const languageDetector = new LanguageDetector();
languageDetector.addDetector({
  name: 'defaultDetector',
  lookup() {
    return supportedLanguages.includes(DEFAULT_LANGUAGE) ? DEFAULT_LANGUAGE : 'en';
  },
});

i18n
  .use(initReactI18next)
  .use(languageDetector)
  .init({
    supportedLngs: supportedLanguages,
    detection: {
      // order and from where user language should be detected
      order: ['querystring', 'cookie', 'localStorage', 'defaultDetector'],
      // keys or params to lookup language from
      lookupQuerystring: 'lng',
      lookupCookie: 'lng',
      caches: ['localStorage', 'cookie'],
      // only detect languages that are in the whitelist
      checkWhitelist: true,
    },
    keySeparator: false,
    nsSeparator: '|',
    fallbackLng: 'en',
    resources,
    debug: false,
    interpolation: {
      escapeValue: false,
      format: (value: string | Date) => {
        if (value instanceof Date) {
          return value.toISOString();
        }

        return value;
      },
    },
  });

export default i18n;
